module.exports = __webpack_public_path__ + "img/wenya-li.4b292435.jpg";